import React, { ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';

import AppBar from '@components/parts/appbar/AppBar';
import { Box, Typography, styled,Button } from '@mui/material';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { AreaInfoDialogState } from '@atom/DialogState';
import { FacilityState } from '@atom/FacilityState';

type OwnProps = {
  title?: string | ReactNode;
  subTitle?: string;
  children?: any;
  isButton?: boolean;
  scheduleSelect?: ReactNode;
};

const Offset = styled('div')(({ theme }) => theme.mixins.toolbar);

const PageBase = ({ title, subTitle, children, isButton, scheduleSelect }: OwnProps) => {
  const facility = useRecoilValue(FacilityState);

  const [searchParams] = useSearchParams();
  const areaIdParam = searchParams.get('areaId') ?? '';
  const facilityIdParam = searchParams.get('facilityId') ?? '';
  const setAreaInfoDialogState = useSetRecoilState(AreaInfoDialogState);

  const showAreaInfo = (event: any, facilityId: string, areaId: string) => {
    event.stopPropagation();
    setAreaInfoDialogState({
      open: true,
      areaInfoData: {
        facilityId,
        areaId
      },
      onDetailClick: () => alert('no function.'),
      onConfirmClick: () => alert('no function.')
    });
  };

  return (
    <div>
      <AppBar facilityName={facility.facilityName} />
      <Offset />
      <Box height="60px">
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          padding="0 1rem"
          height="80px"
          sx={{
            position: 'fixed',
            top: '45px',
            color: '#545F71',
            fontWeight: 'bold',
            zIndex: 998,
            backgroundColor: '#FFFFFF',
            width: '100%'
          }}
        >
          <Box display="flex" flexDirection="column">
            <Typography variant="h5" sx={{ color: '#545F71', fontWeight: 'bold' }}>
              {title}
            </Typography>
            <Typography>{subTitle}</Typography>
          </Box>
          <Box display="flex" flexDirection="row" alignItems="center">
            {scheduleSelect}

            {isButton ? (
              <Button
                sx={{
                  backgroundColor: '#EEF1F4',
                  color: '#545F71',
                  borderColor: 'white',
                  borderRadius: '15px',
                  fontWeight: '400',
                  fontSize: '10px'
                }}
                onClick={(event) => showAreaInfo(event, facilityIdParam, areaIdParam)}
              >
                詳細情報
              </Button>
            ) : null}
          </Box>
        </Box>
      </Box>

      <div>{children}</div>
    </div>
  );
};

PageBase.defaultProps = {
  title: '指定なし',
  subTitle: '',
  children: <p>指定なし</p>,
  isButton: true,
  scheduleSelect: null
};
export default PageBase;
